<template>
  <div>
    <main-layout>
      <v-container>
        <v-breadcrumbs :items="breadcrumbItems">
          <template v-slot:item="props">
            <router-link
              :to="{ name: 'branch-management' }"
              :class="[props.item.disabled && 'disabled']"
              >{{ props.item.text.toUpperCase() }}</router-link
            >
          </template>
        </v-breadcrumbs>
        <div>
          <v-layout wrap>
            <v-flex xs6>
              <h5>{{ $t('sub_branch_management') }}</h5>
            </v-flex>
          </v-layout>
        </div>
        <v-data-table
          hide-actions
          :loading="loading"
          :headers="headers"
          :items="subBranchData"
          :pagination.sync="pagination"
          class="elevation-1 mt-3"
        >
          <template v-slot:items="props">
            <tr>
              <td>{{ props.index + 1 }}</td>
              <td>{{ props.item.sub_page_id }}</td>
              <td>{{ props.item.pagename || '-' }}</td>
            </tr>
          </template>
        </v-data-table>
        <div class="mt-2">
          <v-pagination
            :total-visible="6"
            v-model="pageNumber"
            @input="handleChangePage"
            :length="pagelength"
          ></v-pagination>
        </div>
      </v-container>
    </main-layout>
  </div>
</template>

<script>
import powerbuyShopServicesApi from '@/api/powerbuy-shop-services'
import { mapGetters } from 'vuex'

export default {
  components: {},
  data() {
    return {
      limit: 10,
      offset: 0,
      pagination: { rowsPerPage: -1, sortBy: '' },
      total: 0,
      pagetmp: 1,
      pageNumber: 1,
      loading: false,
      headers: [
        { text: 'No.', value: '', sortable: false },
        { text: 'Page ID', value: 'sub_page_id', sortable: false },
        { text: 'Page name', value: 'pagename', sortable: false }
      ],
      subBranchData: [],
      breadcrumbItems: [
        {
          text: 'Branch Management',
          disabled: false,
          href: 'branch-management'
        },
        {
          text: 'View',
          disabled: true,
          href: 'branch-management'
        }
      ]
    }
  },
  async mounted() {
    await this.handleGetSubBranch()
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        let total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    }
  },
  methods: {
    async handleGetSubBranch() {
      const vm = this
      try {
        const response = await vm.getBranchSub()
        if (response) {
          vm.subBranchData = response.data
          vm.total = response.total
        }
      } catch (error) {
        console.error(error)
        return
      }
    },
    async getBranchSub() {
      const vm = this
      try {
        const id = vm.$route && vm.$route.params.id
        let data = {
          pageId: vm.selectedBot.pageid,
          shop_id: id,
          limit: vm.limit,
          offset: vm.offset
        }

        vm.$store.dispatch('loading')
        const response = await powerbuyShopServicesApi.getBranchSub({
          config: {
            params: data
          }
        })

        vm.$store.dispatch('loading')
        if (response && response.status === 200) {
          return response.data
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
      }
    },
    handleChangePage(val) {
      const vm = this
      if (this.pagetmp !== val) {
        vm.pagetmp = val
        vm.offset = vm.pageNumber * vm.limit - vm.limit

        vm.handleGetBranch()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.disabled {
  color: grey;
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/powerbuy/BranchManagement/SubBranchManagement.vue